export const DEMO_COOKIE = {
  name: 'lt-hide-map-controls-demo',
  expires: 2 * 7 * 24 * 60 * 60, // 2 weeks in seconds
};

// Minimum level of zoom to see the extra layers
export const LAYERS_MIN_ZOOM = 11;
